import moment from 'moment-timezone';

const formatDateTime = (date?: string, format?: string) => {
  if (!date) return '';
  return moment(date).format(format ? format : 'YYYY-MM-DD HH:mm:ss');
};

export default formatDateTime;
